<template>
  <div
    :id="`chat-footer${keyAfter}`"
    v-clickoutside="resetFooterList"
    data-qa="history-inner-chat">
    <sChatInput
      ref="editor"
      acess-empty-text
      class="width-100 history-footer"
      :class="{'small': small}"
      data-qa="history-inner-chat-input"
      :delta-marker-vertical="-228"
      :disabled="loading"
      :disabled-keys="showTags ? ['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'ArrowRight', 'ArrowLeft'] : ['Escape']"
      :file-count="modalFiles ? modalFiles.length : 0"
      :file-show="true"
      :key-after="keyAfter"
      :loading="loading"
      :max-height="'30vh'"
      :value.sync="textMutable"
      @addFile="fileModalShow = true"
      @arrowDown="updateActiveUpOrDown(1)"
      @arrowLeft="updateActiveLeftOrRightTag(-1)"
      @arrowRight="updateActiveLeftOrRightTag(1)"
      @arrowUp="updateActiveUpOrDown(-1)"
      @change="updateFooterList"
      @changeCursorPosition="showPositionMarker"
      @click="updateFooterList"
      @enter="selectItem"
      @escape="escapeTextarea"
      @keydown="inputKeydown"
      @resize="val => $emit('resize', (val + 52))"
      @send="sendMessage">
      <template
        v-slot:beforeInput>
        <slot
          name="beforeInput"/>
      </template>
      <div
        slot="afterInput"
        class="flex">
        <template
          v-for="tag in tags">
          <sButton
            :key="`name-${tag.name}`"
            :alt="`${tag.name} tag`"
            :data-qa="`history-inner-chat-${tag.name}-tag`"
            :disabled="!!filteredTag.length || loading"
            :icon="tag.icon"
            small
            type="text"
            @click="addedTagToText(tag.code)"/>
        </template>
      </div>
      <template slot="cursorPosition">
        <TagUser
          v-if="currentTag === '@'"
          :active-up-or-down="activeUpOrDownTag"
          data-qa="history-inner-chat-tag-user"
          :filtered-users-tag.sync="filteredTag"
          :select-item="selectUsersTagItem"
          @activate-item="activeUpOrDownTag = 0"
          @select-user-tag="selectUserTag($event)"/>
        <TagHash
          v-else-if="currentTag"
          :active-left-or-right="activeLeftOrRightTag"
          :active-up-or-down="activeUpOrDownTag"
          data-qa="history-inner-chat-tag-hash"
          :filtered-tag.sync="filteredTag"
          :options="{tender: tenderItems && tenderItems.length > 1, lot: lotItems && !!lotItems.length, bid: bidItems && !!bidItems.length}"
          :select-item="selectHashTagItem"
          :type="hashType"
          @activate-item="() => {activeLeftOrRightTag = 0; activeUpOrDownTag = 0}"
          @changeType="changeTypeHashTag"
          @select-hash-tag="selectHashTag($event)"/>
      </template>
    </sChatInput>
    <ModalDocumentAdd
      data-qa="history-inner-chat-modal-document-add"
      :files.sync="modalFiles"
      :loading="loading"
      :multiple="true"
      :show.sync="fileModalShow"/>
  </div>
</template>
<script>
import TagHash from 'components/common/blocks/inner-chat/TagHash.vue'
import TagUser from 'components/common/blocks/inner-chat/TagUser.vue'
import ModalDocumentAdd from 'components/common/blocks/history/ModalDocumentAdd.vue'
import { debounce } from 'toolkit/utils/util'
import { doomMixin } from 'mixins'
import filteredItems from './filter-items'
import Clickoutside from 'toolkit/utils/clickoutside'
import textFunctions from 'mixins/textFunctions'

export default {
  name: 'historyInnerChatInput',
  mixins: [textFunctions, doomMixin],
  directives: { Clickoutside },
  data() {
    return {
      fileModalShow: false,
      tags: {
        User: {
          id: 0,
          icon: 'at-sign',
          name: 'User',
          code: '@',
        },
        Hash: {
          id: 1,
          icon: 'sharp',
          name: 'Hash',
          code: '#',
        },
      },

      selectUsersTagItem: null,
      selectedUsersTag: [],

      activeLeftOrRightTag: null,
      selectHashTagItem: null,
      selectedHashTag: [],
      hashType: 'tender',

      activeUpOrDownTag: null,
      filteredTag: [],
      currentTag: null,
      tagTop: 80,
      tagLeft: null,
      cursorRangePosition: null,
    }
  },
  methods: {
    sendMessage: debounce(async function (value) {
      this.$emit('send', {
        value: this.$_escapeHtml(value),
        files: this.files,
        spr: {
          hashTag: this.selectedHashTag,
          userTag: this.selectedUsersTag
        }
      })
      this.modalFiles = []
    }, 200),
    inputKeydown(e) {
      if (e.ctrlKey || e.code === 'Space') {
        this.sendEventChange()
      }
    },
    sendEventChange() {
      this.$nextTick(() => {
        this.getEditorRef().$emit('change')
      })
    },
    /**
     * Изменяем тип хештега (заменяем в строке старый на новый)
     */
    changeTypeHashTag(hashTagType) {
      if (!hashTagType || !hashTagType.hash) { return }

      if (this.hashType === hashTagType.key) { return }

      this.hashType = hashTagType.key

      const { position, endPosition } = this.getPrewTag(this.currentTag)

      this.textMutable = this.textMutable.substr(0, position - this.currentTag.length) +
        hashTagType.hash +
        this.textMutable.substr(endPosition, this.textMutable.length - 1)

      this.setNewSelectionStart((hashTagType.hash.length - this.currentTag.length) - 1 )

      this.currentTag = hashTagType.hash

      this.focusTextarea()
      // updateFooterList читает this.textMutable/currentTag, а textMutable — .sync-проп:
      // сразу после присвоения выше он ещё не долетел от родителя (Vue обновляет пропсы
      // асинхронно), поэтому синхронный вызов здесь безусловно откатывал currentTag/hashType
      // назад к старому тегу (перезаписывая только что переключённый тип). Переносим вызов
      // на nextTick, когда обновлённый текст уже долетит до компонента.
      this.$nextTick(() => {
        this.sendEventChange()
        this.updateFooterList()
      })
    },
    /**
     * Добавление тега по кнопке
     */
    addedTagToText(tag) {
      if (!this.getEditorRef() || this.showTags) { return }

      const newText = ` ${tag} `
      if (!this.getEditorRef().focused) {
        this.getTextareaRef().click()
      }
      if (this.textMutable?.length) {
        const currentSelectionStart = this.getTextareaRef().selectionStart

        this.textMutable = this.textMutable.substr(0, currentSelectionStart) +
        newText +
        this.textMutable.substr(currentSelectionStart, this.textMutable.length - 1)
      } else {
        this.textMutable = tag
      }
      this.setNewSelectionStart(1)
      this.focusTextarea()
      this.$nextTick(() => {
        this.sendEventChange()
      })
    },
    /**
     * Обработка изменения текста (вызов фильтрации тегов и т.п.)
     */
    updateFooterList() {
      if (!this.getTextareaRef()) { return }
      const prewTag = this.getPrewTag()

      if (!prewTag) { return }

      this.currentTag = prewTag.tag

      const textareaCursorPosition = this.getTextareaRef().selectionStart

      if (!this.textMutable?.length) {
        this.resetFooterList()
        return
      }

      const beforeTag = this.textMutable.charAt(textareaCursorPosition)
      const notLetterNumber = !beforeTag.match(/^[0-9a-zA-Z]+$/)

      if (prewTag.tag &&
        (!beforeTag || beforeTag === ' ' || notLetterNumber)
      ) {
        const query = this.textMutable.substring(prewTag.position + (prewTag.tag ? prewTag.tag.length : 0), textareaCursorPosition)

        if (prewTag.tag === '@') {
          const filter = user => user.contactId !== this.currentUser.tenderSettings.contactId
          const sort = (a, b) => { return a.name?.localeCompare(b.name) }
          this.updateShowTag(query, 'userItems', 'name', filter, sort)
        } else if (prewTag.tag === '#' || prewTag.tag === '##' || prewTag.tag === '###') {
          let spr = 'tenderItems'
          if (prewTag.tag === '###') {
            this.hashType = 'tender'
          } else if (prewTag.tag === '#') {
            this.hashType = 'lot'
            spr = 'lotItems'
          } else if (prewTag.tag === '##') {
            this.hashType = 'bid'
            spr = 'bidItems'
          }
          this.updateShowTag(query, spr, 'title', null)
        }
      } else {
        this.resetFooterList()
      }
    },
    getPrewTag(tagChar) {
      const textareaCursorPosition = this.getTextareaRef().selectionStart

      if (!this.textMutable) {
        return {
          tag: null,
          position: -1,
          endPosition: -1
        }
      }
      let checkString = this.textMutable.substring(0, textareaCursorPosition)
      checkString = ` ${checkString}`

      if (tagChar) {
        const space = textareaCursorPosition > tagChar.length
          ? ' '
          : ''
        const position = checkString.lastIndexOf(`${space}${tagChar}`)
        if (position === -1) {
          return {
            tag: tagChar,
            position: -1,
            endPosition: -1
          }
        }
        const positionResult = space && space.length ? position : position - 1
        return {
          tag: tagChar,
          position: positionResult + tagChar.length,
          endPosition: this.getTextareaRef().selectionEnd
        }
      }

      // Порядок важен. find берет первый эллемент
      let checkTags = [
        {tag: '@', position: -1, endPosition: -1},
        {tag: '###', position: -1, endPosition: -1},
        {tag: '##', position: -1, endPosition: -1},
        {tag: '#', position: -1, endPosition: -1},
      ]
      for (var i = 0; i < checkTags.length; i++) {
        const space = textareaCursorPosition > checkTags[i].tag.length
          ? ' '
          : ''
        var tag = `${space}${checkTags[i].tag}`
        const position = checkString.lastIndexOf(tag)
        if (position !== -1) {
          checkTags[i].position = space && space.length ? position : position - 1
          checkTags[i].endPosition = checkTags[i].position + checkTags[i].tag.length
        }
      }
      const maxPosition = Math.max.apply(Math, checkTags.map(function(o) { return o.position }))

      if (maxPosition !== -1) {
        return checkTags.filter(i => i.position !== -1).find(i => i.position === maxPosition)
      }

      return {
        tag: null,
        position: 0,
        endPosition: 0
      }
    },
    /**
     * Сброс состояния списков
     */
    resetFooterList() {
      this.filteredTag = []
    },
    /**
     * отмена введенного текста
     */
    escapeTextarea() {
      if (this.showTags) {
        this.filteredTag = []
      } else { this.resetMessage() }
    },
    updateActiveLeftOrRightTag(direction) {
      if (this.showTags) {
        this.activeLeftOrRightTag = direction
      }
    },
    updateActiveUpOrDown(direction) {
      if (this.showTags) {
        this.activeUpOrDownTag = direction
      }
    },
    selectItem() {
      if (!this.showTags) {
        return
      }
      if (this.currentTag === '@') {
        this.selectUsersTagItem = true
      } else {
        this.selectHashTagItem = true
      }
    },
    showPositionMarker(coordinates) {
      if (!coordinates) { return }

      this.tagTop = coordinates.top
      this.tagLeft = coordinates.left
    },
    updateShowTag(query, spr, fieldTitle, filter, sort) {
      const resultFilteredItems = filteredItems(
        this[spr],
        fieldTitle,
        query,
        true
      )

      this.filteredTag = filter ? resultFilteredItems.filter(filter).sort(sort) : resultFilteredItems

      this.$nextTick(() => {
        this.getEditorRef().checkMarkerWidth()
      })
    },
    selectUserTag(value) {
      this.selectUsersTagItem = false

      if (!value) { return }

      const { position, endPosition } = this.getPrewTag(this.currentTag)
      value.hash = this.currentTag

      this.currentTag = null

      const space = this.textMutable.substr(endPosition, endPosition).length
        ? ''
        : ' '
      const newText = `${value.name}${space}`
      this.textMutable = this.textMutable.substr(0, position) +
        newText +
        this.textMutable.substr(endPosition, this.textMutable.length - 1)
      this.selectedUsersTag = [...this.selectedUsersTag, { ...value }]

      this.setNewSelectionStart(newText.length)

      this.focusTextarea()
    },
    selectHashTag(value) {
      this.selectHashTagItem = false

      if (!value) { return }

      const { position, endPosition } = this.getPrewTag(this.currentTag)
      value.hash = this.currentTag

      this.currentTag = null

      const space = this.textMutable.substr(endPosition, endPosition).length
        ? ''
        : ' '

      const newText = `${value.title}${space}`

      this.textMutable = this.textMutable.substr(0, position) +
        newText +
        this.textMutable.substr(endPosition, this.textMutable.length - 1)
      this.selectedHashTag = [...this.selectedHashTag, { ...value }]

      this.setNewSelectionStart(newText.length)

      this.focusTextarea()
    },
    setNewSelectionStart(delta) {
      const currentSelectionStart = this.getTextareaRef().selectionStart
      const newSelectionStart = currentSelectionStart + delta
      this.cursorRangePosition = newSelectionStart + 1
    },
    resetMessage() {
      this.selectedUsersTag = []
      this.selectedHashTag = []
      this.textMutable = ''
      setTimeout(() => this.focusTextarea())
    },
    focusTextarea() {
      if (!this.getTextareaRef()) { return }
      this.getTextareaRef().focus()
      if (this.cursorRangePosition) {
        setTimeout(() => {
          this.getTextareaRef().setSelectionRange(
            this.cursorRangePosition,
            this.cursorRangePosition
          )
          this.cursorRangePosition = null
          this.sendEventChange()
        })
      } else {
        this.sendEventChange()
      }
    },
    getEditorRef() {
      return this.$refs.editor
    },
    getTextareaRef() {
      return this.getEditorRef()?.$refs.textareaChatInput
    }
  },
  computed: {
    textMutable: {
      get() {
        return this.text ?? ''
      },
      set(value) {
        this.$emit('update:text', value)
      }
    },
    modalFiles: {
      get() {
        return this.files ?? []
      },
      set(value) {
        this.$emit('update:files', value)
      }
    },
    showTags() {
      return !!this.filteredTag?.length
    },
    tenderItems() {
      if (!this.hashItems?.length) { return [] }
      return this.hashItems.filter(i => i.type === 'tender')
    },
    lotItems() {
      if (!this.hashItems?.length) { return [] }
      return this.hashItems.filter(i => i.type === 'lot')
    },
    bidItems() {
      if (!this.hashItems?.length) { return [] }
      return this.hashItems.filter(i => i.type === 'bid')
    },
    currentUser() {
      return this.$store.getters['GET_USER']
    },
  },
  props: {
    text: String,
    files: Array,
    /** Признак загрузки */
    loading: {
      type: Boolean
    },
    userItems: {
      type: Array
    },
    hashItems: {
      type: Array
    },
    small: {
      type: Boolean
    },
    keyAfter: {
      type: String,
      default: ''
    }
  },
  components: {
    TagHash,
    TagUser,
    ModalDocumentAdd
  }
}
</script>
<style scoped lang="scss">
.history-footer.small::v-deep {
  .chat-input-count {
    height: 26px;
    margin: 0 !important;
    .s-btn {
      padding: 0;
      min-height: 26px;
      min-width: 26px;
      margin-left: 5px;
      &:first-of-type {
        margin-left: 0 !important;
      }
    }
  }
  .chat-input {
    padding: 10px 10px !important;
    line-height: 13px;
  }
}
.history-footer {
  position: relative;
  width: 100%;
  z-index: 1;
  //transition: all 0.25s;
}
.tag-modal {
  background: var(--v-main__light_green-base);
  border-radius: 5px;
  border: 2px solid var(--color-main-green);
  &__body {
    margin: 0;
  }
  &__headed {
    border-bottom: 1px solid var(--color-main-green);
    text-align: right;
    button {
      padding: 0 !important;
      min-height: 26px !important;
      min-width: 26px !important;
    }
  }
  &__content {
    max-height: 230px;
    overflow: auto;
  }
}
.inner-chat-card_tag {
  font-weight: bold;
  //margin: 0 5px;
  cursor: pointer;
  &-0 {
    font-weight: 600;
    text-decoration: underline;
  }
  &-1 {
    text-decoration: underline;
  }
  &-2 {
    text-decoration: underline;
  }
}
</style>
